import { NavLink } from "react-router-dom"
import { useAuthContext } from "../hooks/useAuthContext"
import { useLogout } from '../hooks/useLogout'

// styles
import styles from './Navbar.module.css'
import './Navbar.css'

export default function Navbar() {
  const { logout } = useLogout()
  const { user } = useAuthContext()
  // nn128

  return (

    <nav className={styles.navbar}>

      <ul>
        <li className={styles.title}>Politicians & Hookers v2b</li>

        {!user && (
          <>
            <li><NavLink to="/login">Login</NavLink></li>
            <li><NavLink to="/signup">Signup</NavLink></li>
            <li><NavLink to="/helpbg">Help</NavLink></li>
          </>
        )}

        {user && (
          <>
            <li>hello, {user.displayName}</li>
            <li>
              <NavLink to="/" >Home</NavLink>
            </li>
            <li>
              <NavLink to="/create" >Create</NavLink>
            </li>
            <li>
              <NavLink to="/myjokes" >myJokes</NavLink>
            </li>
            <li>
              <NavLink to="/help" >Help</NavLink>
            </li>
            <li>
              <button className="btn" onClick={logout}>Logout</button>
            </li>
          </>
        )}
      </ul>
    </nav>

  )
}
